<script lang="ts">
  import type { Event, EventHoursOccurrence } from "../../types";
  import Description from "../description.svelte";
  import Hero from "../hero.svelte";
  import Schedule from "./schedule.svelte";
  import { getNow, getTimeZone } from "../../data/clock";

  export let event: Event;
  export let schedule: EventHoursOccurrence[] = [];

  export let time = getNow();
  export let timeZone = getTimeZone();
</script>

<main class="Container">
  <Hero src={event.graphic} alt="Photo of {event.title}" />

  <Schedule {event} {schedule} {time} {timeZone} />

  <Description text={event.description} />
</main>

<style>
  .Container {
    flex: 1 1 auto;
    hyphens: auto;
    overflow: auto;
    position: relative;
    width: 100%;
  }
</style>
